module.exports = __webpack_public_path__ + "img/Airbnb-Working-From-a-Listing-Posture-Perfect-1.943cace9.jpg";